import {useEffect, useState} from 'react';
import {setCssVar} from 'core/helpers';
import {RUNTIME_CSS_VARS, RUNTIME_CSS_VARS_DEFAULT_VALUES} from 'core/constants';
import {useIsomorphicLayoutEffect} from 'core/hooks/useIsomorficLayoutEffect';

export const useAdaptTopMenuPosition = (isHeaderTopHidden: boolean) => {
    const [bodyTopPadding, setBodyTopPadding] = useState(0);

    // Хак для выравнивания отступа у оверлея меню при активном баннере flocktory
    useEffect(() => {
        const config = {attributes: true, childList: false, subtree: false};

        const callback = (mutationList: MutationRecord[]) => {
            for (const mutation of mutationList) {
                if ('attributes' === mutation.type) {
                    const paddingTop = Number.parseInt(document.body.style.paddingTop, 10) || 0;

                    if (!Number.isNaN(paddingTop) && paddingTop !== bodyTopPadding) {
                        setBodyTopPadding(paddingTop);
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);

        observer.observe(document.body, config);

        const paddingTop = Number.parseInt(document.body.style.paddingTop, 10) || 0;

        if (!Number.isNaN(paddingTop) && paddingTop !== bodyTopPadding) {
            setBodyTopPadding(paddingTop);
        }

        return () => {
            observer.disconnect();
        };
    }, [bodyTopPadding]);

    useIsomorphicLayoutEffect(() => {
        setCssVar({
            cssVarName: RUNTIME_CSS_VARS.menuTop,
            unit: 'px',
            value: isHeaderTopHidden
                ? RUNTIME_CSS_VARS_DEFAULT_VALUES.menuTopCollapsed + bodyTopPadding
                : RUNTIME_CSS_VARS_DEFAULT_VALUES.menuTop + bodyTopPadding,
        });
    }, [isHeaderTopHidden, bodyTopPadding]);
};
